"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IEventHeader.js.map